module.exports = __webpack_public_path__ + "img/alicoupon.36864024.jpg";